import { useEffect } from 'react';
import { useState } from 'react';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { BottomModal } from '../shared/BottomModal';
import { TopUpPanel } from './TopUpPanel';
import { toast } from 'react-toastify';
import { GiftsList } from './GiftList';
import { apiGifts } from '../../api/apiGifts.api';
import { useNavigate } from 'react-router-dom';
import config from '../../config';

function GiftsShopModal({ onClose, onRefetchFn }) {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const [option, setOption] = useState(1);
  const [loadingGifts, setLoadingGifts] = useState(false);
  const [isLoadingBuyGift, setIsLoadingBuyGift] = useState(false);
  const [userCoins, setUserCoins] = useState(0);

  const [presents, setPresents] = useState([]);
  const [myPresents, setMyPresents] = useState([]);

  const fetchUserBalance = async () => {
    try {
      const response = await axiosPrivate.get(`/users/me`);
      setUserCoins(response.data.data.wallet.coins || 0);
    } catch (error) {
      console.error('Ошибка при загрузке баланса:', error);
    }
  };

  const fetchBuyGift = async (giftId) => {
    apiGifts
      .fetchBuyGift(axiosPrivate, setIsLoadingBuyGift, giftId)
      .then((res) => {
        setUserCoins(res.coins);
        apiGifts.fetchMyGifts(axiosPrivate, setLoadingGifts).then((gifts) => setMyPresents(gifts.filter((gift) => gift.isBought)));
        onRefetchFn();
      })
      .catch(toast.error);
  };

  const disableBuy = isLoadingBuyGift;

  useEffect(() => {
    fetchUserBalance();

    apiGifts.fetchGifts(axiosPrivate, setLoadingGifts).then(setPresents);
    apiGifts.fetchMyGifts(axiosPrivate, setLoadingGifts).then((gifts) => setMyPresents(gifts.filter((gift) => gift.isBought)));
  }, []);

  return (
    <BottomModal isOpen={true} onClose={() => onClose()}>
      <div className="w-full h-full flex flex-col bg-[#043939] text-white font-raleway overflow-hidden relative">
        <div className="px-4 h-[50px] rounded-full mb-1 flex-shrink-0">
          <div className="flex flex-row h-[44x] bg-white/10 rounded-[8px] p-1">
            <button
              className={`flex-1 flex items-center h-[33px] rounded-full justify-center text-[14px] font-medium transition-colors ${
                option === 1 ? 'bg-white/10 text-[#A1F69E]' : 'text-white'
              }`}
              onClick={() => setOption(1)}
            >
              Магазин подарков
            </button>
            <button
              className={`flex-1 flex items-center justify-center rounded-full text-[14px] font-medium transition-colors ${
                option === 2 ? 'bg-white/10 text-[#A1F69E]' : 'text-white'
              }`}
              onClick={() => setOption(2)}
            >
              Купленные подарки
            </button>
          </div>
        </div>

        <div
          className="flex-1 overflow-y-auto mt-2 px-4 min-h-[200px]"
          style={{
            WebkitOverflowScrolling: 'touch',
            overscrollBehavior: 'contain',
          }}
        >
          <GiftsList
            gifts={option === 1 ? presents : myPresents}
            loading={loadingGifts}
            renderAction={(item, isSelected) => {
              return isSelected && option === 1 ? (
                <button
                  className="absolute bottom-0 left-0 right-0 h-[29px] bg-[#A1F69E] flex items-center justify-center transition-colors"
                  onClick={(e) => {
                    e.stopPropagation();
                    fetchBuyGift(item._id);
                  }}
                  disabled={disableBuy}
                >
                  <span className="text-[#010D0D] text-[12px] font-semibold">Купить</span>
                </button>
              ) : isSelected && option === 2 ? (
                <button
                  className="absolute bottom-0 left-0 right-0 h-[29px] bg-[#A1F69E] flex items-center justify-center transition-colors"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(config.ROUTES.CHATS.LIST);
                  }}
                >
                  <span className="text-[#010D0D] text-[12px] font-semibold">Отправить</span>
                </button>
              ) : null;
            }}
            renderNotGifts={() => {
              return option === 1 ? (
                <div className="flex flex-col items-center justify-center py-12">
                  <div className="text-[48px] mb-4">🎁</div>
                  <p className="text-white/60 text-[16px] text-center font-raleway">Подарки временно недоступны</p>
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center py-12">
                  <div className="text-[48px] mb-4">🎁</div>
                  <p className="text-white/60 text-[16px] text-center font-raleway">
                    У вас пока нет купленных подарков
                  </p>
                </div>
              );
            }}
          />
        </div>

        <TopUpPanel userCoins={userCoins} />
      </div>
    </BottomModal>
  );
}

export default GiftsShopModal;
